import request from "@/utils/request";

export function qcSchemeGetallApi(params) {
  return request({
    url: "?c=qc&a=scheme&do=getall",
    method: "get",
    params
  });
}

export function qcSchemeListApi(params) {
  return request({
    url: "?c=qc&a=scheme&do=list",
    method: "get",
    params
  });
}

export function postSchmeApi(data) {
  return request({
    url: "?c=qc&a=scheme&do=post",
    method: "post",
    data: data
  });
}

export function getSchemeApi(params) {
  return request({
    url: "?c=qc&a=scheme&do=get",
    method: "get",
    params
  });
}

export function delSchmeApi(data) {
  return request({
    url: "?c=qc&a=scheme&do=del",
    method: "post",
    data: data
  });
}
